module['exports'] = [
  'خیبر پختونخواہ',
  'اسلام آباد',
  'پنجاب',
  'سندھ',
  'آزاد کشمیر',
  'بلوچستان',
  'گلگت بلتستان',
];
